<template>
  <div class="mt-4 mt-sm-2 mx-2" ref="topOfPage">
    <v-fade-transition>
      <div>
        <v-card
          v-if="!selectedLens"
          class="titlebar d-flex flex-row flex-wrap px-4 py-2 justify-space-between"
          flat
          outlined
        >
          <div class="pr-4">
            <div class="text-h4">Hybrid Lenses</div>
            <div class="caption ml-2">(All lenses are from SynergEyes)</div>
          </div>
          <div class="d-flex flex-row flex-wrap mt-2">
            <div class="pt-2 pr-4">
              <v-btn-toggle
                v-model="filters.type"
                rounded
                class="toggleBtns"
                active-class="orangeActive"
              >
                <v-btn small value="ALL">ALL</v-btn
                ><v-btn small value="SPHERE">Single Vision</v-btn
                ><v-btn small value="BIFOCAL">Multifocals</v-btn>
              </v-btn-toggle>
            </div>
            <v-checkbox
              class="mt-3 mb-3 mt-sm-1 mb-sm-1 mr-4"
              v-model="filters.high_dk"
              label="Only high dk skirts"
              hide-details="auto"
              dense
            ></v-checkbox>
          </div>
          <div>&nbsp;</div>
        </v-card>
      </div>
    </v-fade-transition>
    <v-fade-transition>
      <!-- lens list -->
      <div v-if="!selectedLens">
        <div class="d-flex flex-row caption mx-4 my-2">
          <div v-if="filterSummary">
            {{ filterSummary }} lenses are hidden by your filters
            <v-btn
              x-small
              rounded
              class="ml-3"
              depressed
              outlined
              color="gray"
              @click="resetFilters()"
              >x Clear Filters</v-btn
            >
          </div>
          <div v-else>Showing all lenses</div>
        </div>
        <div class="d-flex flex-row flex-wrap mt-2">
          <v-card
            v-for="lens in filteredLenses"
            :key="lens.id"
            class="ma-2 pa-2 d-flex flex-row blooBerder"
            color="#f2f9ff"
            hover
            flat
            :loading="loading"
            :width="cardSizeForScreen"
            @click="
              lensSlug = lens.slug;
              scrollToTop();
            "
          >
            <div class="imgDiv mt-2">
              <product-image
                :fileString="lens.image"
                type="scl"
                :maxWidth="130"
                :maxHeight="60"
              ></product-image>
            </div>
            <div class="pa-2">
              <div class="font-weight-bold">{{ lens.name }}</div>
              <div class="caption">
                {{ lens.polymer.pn_poly_name }} <br />(
                {{ lens.polymer.pn_poly_dk }} dK, {{ lens.polymer.pn_h2o }}%
                H<sub>2</sub>O )
              </div>
            </div>
          </v-card>
        </div>
        <!-- / end lens list -->
      </div>

      <div v-else>
        <!-- lens details -->
        <div class="d-flex flex-row">
          <v-spacer></v-spacer>
          <v-btn
            @click="clearDetails()"
            small
            outlined
            color="primary"
            class="mb-1"
          >
            <v-icon small color="primary">mdi-step-backward</v-icon>Back to All
            Hybrid Lenses
          </v-btn>
        </div>
        <hybrid-details :lens="selectedLens"></hybrid-details>

        <!-- end lens details -->
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import ProductImage from "./ProductImage.vue";
import HybridDetails from "./HybridDetails.vue";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";

// import Name from "../dir/file";

export default {
  components: {
    ProductImage,
    HybridDetails,
  },
  mixins: [FiltersMixin],
  name: "Hybrids",
  props: {},
  data: function () {
    return {
      lenses: null,
      //   polymers: null,
      lensSlug: null,
      loading: false,
      filters: { ...FilterDictionary.filterDefaults },
      //   filterDefaults: { ...FilterDictionary.filterDefaults },
      desiredType: null, // "SPHERE" or "BIFOCAL"
      high_dk: 0,
    };
  },
  methods: {
    resetFilters() {
      this.filters.type = null;
      this.filters.high_dk = 0;
    },
    getLenses() {
      this.loading = true;
      if (this.lenses) return;
      ApiServices.genericApiCall("/lens/hybrids")
        .then((response) => {
          if (response.data.lenses) this.lenses = response.data.lenses;
          //   if (response.data.polymers) this.polymers = response.data.polymers;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    clearDetails() {
      this.lensSlug = null;
      this.updateHashWithParamString("");
    },
    handleHistoryChange() {
      // console.log("hybrid history changed");
      if (!this.lenses) this.getLenses();
      let slug = this.hashValForKey("lens"); // (this function is from the mixin)
      if (slug) this.lensSlug = slug;
      if (!slug) this.lensSlug = null;
      // this.filters.type = null;
      this.setFiltersFromHash();
      if (!this.filters.type) this.filters.type = "ALL";
      delete this.filters.replace; // just to keep it showing up in the hash (since it's not relevant here)
      this.scrollToTop();
    },
    scrollToTop() {
      this.$nextTick(() => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });
    },
  },
  computed: {
    cardSizeForScreen: function () {
      let rtn = "100%";
      if (this.$vuetify.breakpoint.smAndUp) rtn = "45%";
      if (this.$vuetify.breakpoint.lgAndUp) rtn = "400";
      return rtn;
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    metaTitle: function () {
      return this.selectedLens ? this.selectedLens.name : "Hybrids";
    },
    selectedLens: function () {
      if (!this.lenses || !this.lensSlug) return null;
      let match = null;
      this.lenses.forEach((lens) => {
        if (lens.slug.toLowerCase() == this.lensSlug.toLowerCase()) {
          match = lens;
        }
      });
      if (match) this.updateHashWithParamString("lens=" + match.slug);
      return match;
    },
    filteredLenses: function () {
      let lenses = this.lenses;
      if (!lenses) return null;
      let f = this.filters;
      let type = f.type;
      let high_dk = f.high_dk;
      let filteredLenses = [];
      //   console.log(type, high_dk);
      lenses.forEach((lens) => {
        let include = true;
        let lensType = lens.type_tag;
        // console.log(lensType);
        if (type && type != lensType && type != "ALL") include = false;
        let dk = parseInt(lens.polymer.pn_poly_dk);
        if (high_dk && dk < 30) include = false;
        if (include) filteredLenses.push(lens);
      });
      return filteredLenses;
    },
    filterSummary: function () {
      if (!this.filteredLenses || this.filteredLenses.length < 1) return null;
      return this.lenses.length - this.filteredLenses.length;
    },
  },
  watch: {
    // $route(to, from) {
    //   console.log(to, from);
    // },
  },
  mounted: function () {
    this.handleHistoryChange();
    window.addEventListener("popstate", this.handleHistoryChange);
  },
  destroyed() {
    window.removeEventListener("popstate", this.handleHistoryChange);
  },
  metaInfo() {
    return {
      title: "EyeDock/CLs | " + this.metaTitle,
    };
  },
};
</script>

<style scoped>
.imgDiv {
  width: 140px;
  height: 80px;
}
.titlebar {
  border: 1px solid #b6c4c8 !important;
  background-color: #e3f2fd;
}
.blooBerder {
  border: 1px solid #cce1f3 !important;
}
</style>
